import { ApolloProvider } from "@apollo/client/react";
import type { ReactNode } from "react";
import { getApolloClient } from "@/infrastructure/adapters/graphql/GraphQl.adapter";

interface StudioApolloProviderProps {
  children: ReactNode;
}

const StudioApolloProvider = ({ children }: StudioApolloProviderProps) => {
  return <ApolloProvider client={getApolloClient()}>{children}</ApolloProvider>;
};

export default StudioApolloProvider;
